const state = {
  type: 'alert-success',
  message: 'success',
};

const getters = {
  getType: (inoNewState) => inoNewState.type,
  getMessage: (inoNewState) => inoNewState.message,
};

const mutations = {
  success(inoSstate, insMessage) {
    const oState = inoSstate;

    oState.type = 'alert-success';
    oState.message = insMessage;
  },
  error(inoSstate, insMessage) {
    const oState = inoSstate;

    oState.type = 'alert-danger';
    oState.message = insMessage;
  },
  clear(inoSstate) {
    const oState = inoSstate;

    oState.type = null;
    oState.message = null;
  },
};

const actions = {
  success({ commit }, message) {
    commit('success', message);
  },
  error({ commit }, message) {
    commit('error', message);
  },
  clear({ commit }, message) {
    commit('success', message);
  },
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations,
};
